module.exports = "/_next/static/images/PennsylvaniaLogo-0e8283184edf3e95ee1c8a7fe89ceb2e.png";